import { Separator1Img, Separator2Img } from "@/assets/images/_index"

export const styleTypeMap = {
  1: Separator1Img,
  2: Separator2Img
}
